// @ts-nocheck

import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faBuilding,
  faHouse,
  faUserGroup,
  faPeopleGroup,
  faBooks,
  faLanguage,
  faBell,
  faUser,
  faCircleArrowUpRight,
  faArrowLeft,
  faArrowRight,
  faPlus,
  faFileExport,
  faClipboardUser,
  faFileUser,
  faTriangleExclamation,
  faXmark,
  faXmarkLarge,
  faChevronUp,
  faChevronDown,
  faUserHelmetSafety,
  faUserTie,
  faMagnifyingGlass,
  faEye,
  faEyeSlash,
  faMinus,
  faChain,
  faChainBroken,
  faLock,
  faUnlock,
  faBars,
  faRotateLeft,
  faEdit,
  faCaretUp,
  faCaretDown,
  faStar,
  faChevronRight,
  faCopy,
  faKey,
  faFloppyDisk,
  faUserPlus,
  faTrophy,
  faTrashCan,
  faFileUpload,
  faBoltLightning,
  faBoxArchive,
  faArrowDown19,
  faCalendarLines,
  faCalendarLinesPen,
  faArrowUp,
  faArrowDown,
  faObjectGroup,
  faObjectUngroup,
  faObjectUnion,
  faObjectIntersect,
  faMerge,
  faSplit,
  faCalendarPlus,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowDownLeftAndArrowUpRightToCenter,
  faThumbsUp,
  faThumbsDown,
  faCommentArrowUp,
  faCircleHalfStroke,
  faUtensils,
  faCheck,
  faCheckDouble,
  faCircle,
  faCircleCheck,
  faCircleQuestion,
  faCircleXmark,
  faEnvelope,
  faEnvelopeCircleCheck,
  faEraser,
  faQuestion,
  faList,
  faDollarSign,
  faTrashXmark,
  faTrashCheck,
  faFilter,
  faCircleDot,
  faBook,
  faSparkles,
  faTableRows,
  faTableColumns,
  faRotate,
  faFire,
  faArrowsLeftRight,
  faImage,
  faArrowUpRight,
  faInfo,
  faShirt,
  faAnchor,
  faArrowsTurnToDots,
  faMarker,
  faHighlighter,
  faFile,
  faEyeLowVision,
  faHighlighterLine,
  faBorderOuter,
  faLineHeight,
  faCogs,
  faCog,
  faPlug,
  faTv,
  faMobile,
  faLaptopMobile,
  faCalendarDays,
} from '@awesome.me/kit-ff9dd7b804/icons/modules/classic/solid';

import { faStar as farStar } from '@awesome.me/kit-ff9dd7b804/icons/modules/classic/regular';

import {
  faChartTreeMap,
  faMemoPad,
  faNewspaper,
} from '@awesome.me/kit-ff9dd7b804/icons/modules/sharp/solid';

import {
  faSolidMobileSlash,
  faSolidPlugSlash,
  faSolidTvSlash,
  faSolidBoxArchiveCircleCheck,
  faSolidBoxArchiveCircleXmark,
  faSolidDollarSignSlash,
  faSolidLanguageSlash,
  faSolidMobileScreenButtonSlash,
  faSolidSignPostsSlash,
  faSolidLaptopMobileSlash,
  faSolidCalendarDaysSlash,
  faSharpSolidNewspaperSlash,
  faSolidTagSlash,
} from '@awesome.me/kit-ff9dd7b804/icons/modules/kit/custom';
import {
  faCircleDollar,
  faExclamation,
  faI,
  faInfoCircle,
  faInventory,
  faP,
  faPaperPlane,
  faPencil,
  faS,
  faSignPosts,
  faSparkle,
  faTachometerFastest,
  faTachometerSlowest,
  faTag,
  faTilde,
  faServer,
  faClone,
  faTasks,
} from '@fortawesome/pro-solid-svg-icons';

// @ts-ignore
library.add(
  faBuilding,
  faHouse,
  faUserGroup,
  faPeopleGroup,
  faBooks,
  faLanguage,
  faBell,
  faUser,
  faCircleArrowUpRight,
  faMemoPad,
  faArrowLeft,
  faArrowRight,
  faArrowUpRight,
  faPlus,
  faFileExport,
  faClipboardUser,
  faFileUser,
  faTriangleExclamation,
  faXmark,
  faXmarkLarge,
  faChevronUp,
  faChevronDown,
  faChartTreeMap,
  faUserHelmetSafety,
  faUserTie,
  faMagnifyingGlass,
  faEye,
  faEyeSlash,
  faMinus,
  faChain,
  faChainBroken,
  faLock,
  faUnlock,
  faBars,
  faRotateLeft,
  faEdit,
  faCaretUp,
  faCaretDown,
  faStar,
  farStar,
  faChevronRight,
  faKey,
  faCopy,
  faFloppyDisk,
  faUserPlus,
  faTrophy,
  faTrashCan,
  faFileUpload,
  faBoltLightning,
  faBoxArchive,
  faArrowDown19,
  faCalendarLines,
  faCalendarLinesPen,
  faArrowUp,
  faArrowDown,
  faObjectGroup,
  faObjectUngroup,
  faObjectUnion,
  faObjectIntersect,
  faMerge,
  faSplit,
  faCalendarPlus,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowDownLeftAndArrowUpRightToCenter,
  faThumbsUp,
  faThumbsDown,
  faCommentArrowUp,
  faCircleHalfStroke,
  faUtensils,
  faCheck,
  faCheckDouble,
  faCircle,
  faCircleCheck,
  faCircleQuestion,
  faCircleXmark,
  faEnvelope,
  faEnvelopeCircleCheck,
  faEraser,
  faQuestion,
  faList,
  faDollarSign,
  faTrashXmark,
  faTrashCheck,
  faFilter,
  faCircleDot,
  faBook,
  faNewspaper,
  faSparkles,
  faTableRows,
  faTableColumns,
  faRotate,
  faFire,
  faArrowsLeftRight,
  faImage,
  faInfo,
  faShirt,
  faAnchor,
  faArrowsTurnToDots,
  faMarker,
  faHighlighter,
  faFile,
  faEyeLowVision,
  faHighlighterLine,
  faBorderOuter,
  faLineHeight,
  faCog,
  faCogs,
  faPlug,
  faTv,
  faMobile,
  faSolidMobileSlash,
  faSolidPlugSlash,
  faSolidTvSlash,
  faSolidBoxArchiveCircleCheck,
  faSolidBoxArchiveCircleXmark,
  faSolidDollarSignSlash,
  faSolidLanguageSlash,
  faSolidMobileScreenButtonSlash,
  faS,
  faI,
  faP,
  faLaptopMobile,
  faSolidLaptopMobileSlash,
  faSignPosts,
  faSolidSignPostsSlash,
  faCalendarDays,
  faSolidCalendarDaysSlash,
  faSharpSolidNewspaperSlash,
  faTag,
  faSolidTagSlash,
  faPaperPlane,
  faTilde,
  faPencil,
  faExclamation,
  faTachometerSlowest,
  faTachometerFastest,
  faInfoCircle,
  faInventory,
  faCircleDollar,
  faSparkle,
  faServer,
  faClone,
  faTasks
);
